/* eslint-disable import/prefer-default-export */
export enum RequestKeys {
    getUserRoles = 'getUserRoles',
    getContractBasisAdditionalFee = 'getContractBasisAdditionalFee',
    getContractBasisAdditionalFeeDetails = 'getContractBasisAdditionalFeeDetails',
    getContractBasisLongTermLeaseFees = 'getContractBasisLongTermLeaseFees',
    getContractBasisLaneFeeDetails = 'getContractBasisLaneFeeDetails',
    getContractBasisLaneGroups = 'getContractBasisLaneGroups',
    getContractBasisLaneGroupsDetails = 'getContractBasisLaneGroupsDetails',
    getContractBasisLaneGroupLaneDetails = 'getContractBasisLaneGroupLaneDetails',
    getContryForStateSelector = 'getContryForStateSelector',
    getSelectedLaneForNewCustomerTransport = 'getSelectedLaneForNewCustomerTransport',
    getOrderNotifications = 'getOrderNotifications',
    getProductTypesContractBasis = 'getProductTypesContractBasis',
    getProductTypesTransportSimulation = 'getProductTypesTransportSimulation',
    getContainerTypes = 'getContainerTypes',
    getContainerType = 'getContainerType',
    getContainerBySerialNumber = 'getContainerBySerialNumber',
    getBillingInformation = 'getBillingInformation',
    getLaneFees = 'getLaneFees',
    getLaneFeesModifications = 'getLaneFeesModifications',
    getContainerLastGeolocation = 'getContainerLastGeolocation',
    getLongTermLeaseModifications = 'getLongTermLeaseModifications',
    getAdditionalFees = 'getAdditionalFees',
    getLongTermLeaseFees = 'getLongTermLeaseFees',
    getAllowedProductTypes = 'getAllowedProductTypes',
    getAllowedLaneFeesFeeNameToChargeAbilityMapping = 'getAllowedLaneFeesFeeNameToChargeAbilityMapping',
    getAllowedAdditionalFeesFeeNameToChargeAbilityMapping = 'getAllowedAdditionalFeesFeeNameToChargeAbilityMapping',
    getAllowedLongTermFeesFeeNameToChargeAbilityMapping = 'getAllowedLongTermFeesFeeNameToChargeAbilityMapping',
    getLogger = 'getLogger',
    getLoggerByLoggerNumber = 'getLoggerByLoggerNumber',
    getLocation = 'getLocation',
    getLocations = 'getLocations',
    getAccount = 'getAccount',
    getAccountLane = 'getAccountLane',
    getAccountLanes = 'getAccountLanes',
    getAccountLanesByOpportunities = 'getAccountLanesByOpportunities',
    getAccountLanesByCompanyNames = 'getAccountLanesByCompanyNames',
    getAQuote = 'getAQuote',
    getAQuotes = 'getAQuotes',
    getAQuoteModifications = 'getAQuoteModifications',
    getLanesToBeGroupedByAQuote = 'getLanesToBeGroupedByAQuote',
    getLaneGroupsPricingAssessment = 'getLaneGroupsPricingAssessment',
    getLaneGroupPricingAssessmentById = 'getLaneGroupPricingAssessmentById',
    getGateway = 'getGateway',
    getGatewayComments = 'getGatewayComments',
    getForecastSubmissionData = 'getForecastSubmissionData',
    getLocationContacts = 'getLocationContacts',
    getBillingCompany = 'getBillingCompany',
    getBillingCompanies = 'getBillingCompanies',
    getCompany = 'getCompany',
    'getLaneGroupSubEntities-LaneFees' = 'getLaneGroupSubEntitiesLaneFees',
    'getLaneGroupSubEntities-Lane' = 'getLaneGroupSubEntitiesLane',
    getAirportsFilteredByLaneGroupIds = 'getAirportsFilteredByLaneGroupIds',
    getStepConfiguration = 'getStepConfiguration',
    getContractBasisProductType = 'getContractBasisProductType',
    getFxRates = 'getFxRates',
    getContainerNoteDetails = 'getContainerNoteDetails',
    getFxRateById = 'getFxRateById',
    getSensorData = 'getSensorData',
    getContactByIds = 'getContactByIds',
    getCountry = 'getCountry',
    getCountriesByIds = 'getCountriesByIds',
    getContact = 'getContact',
    getLaneFeeSelector = 'getLaneFeeSelector',
    getAdditionalFeeSelector = 'getAdditionalFeeSelector',
    getMainCategory = 'getMainCategory',
    getCustomerExecution = 'getCustomerExecution',
    getSharePositioningList = 'getSharePositioningList',
    getSharePositioning = 'getSharePositioning',
    getContainer = 'getContainer',
    getDamage = 'getDamage',
    getDamageModifications = 'getDamageModifications',
    getAttachment = 'getAttachment',
    getContractBasis = 'getContractBasis',
    getLoggerContainerInformation = 'getLoggerContainerInformation',
    getLaneFeesByLaneGroup = 'getLaneFeesByLaneGroup',
    getLaneFeesTemplate = 'getLaneFeesTemplate',
    getPositionsByInvoiceId = 'getPositionsByInvoiceId',
    getLaneByLaneGroup = 'getLaneByLaneGroup',
    getOrderCountForLaneFee = 'getOrderCountForLaneFee',
    getOrderCountForAdditionalFee = 'getOrderCountForAdditionalFee',
    getLocationById = 'getLocationById',
    getLaneOpsInformationById = 'getLaneOpsInformationById',
    getUser = 'getUser',
    getUsers = 'getUsers',
    getRegionalGroupById = 'getRegionalGroupById',
    getRegionalGroupsByAccount = 'getRegionalGroupsByAccount',
    getAvailableLanes = 'getAvailableLanes',
    getLocationAreaDetailsByLocationId = 'getLocationAreaDetailsByLocationId',
    getLocationArea = 'getLocationArea',
    getAlLeasePricing = 'getAlLeasePricing',
    getAlLogisticPricing = 'getAlLogisticPricing',
    getDamageByContainer = 'getDamageByContainer',
    getContainerSensorChecks = 'getContainerSensorChecks',
    getOpportunityById = 'getOpportunityById',
    getOpportunities = 'getOpportunities',
    getDeletedLoggerHistory = 'getDeletedLoggerHistory',
    getLaneGroupModifications = 'getLaneGroupModifications',
    getLaneGroupLaneFeesModifications = 'getLaneGroupLaneFeesModifications',
    getLaneGroupLaneModifications = 'getLaneGroupLaneModifications',
    getOpportunityModifications = 'getOpportunityModifications',
    getLocationFilterRequest = 'getLocationFilterRequest',
    getLoggerTypeDetails = 'getLoggerTypeDetails',
    getTemperatureSimulation = 'getTemperatureSimulation',
    getLaneById = 'getLaneById',
    getLanes = 'getLanes',
    getGatewayModifications = 'getGatewayModifications',
    getOpportunitiesForRegionalGroups = 'getOpportunitiesForRegionalGroups',
    getOpportunitiesByAccount = 'getOpportunitiesByAccount',
    getCo2Calculation = 'getCo2Calculation',
    getPositionTypeMapping = 'getPositionTypeMapping',
    getAvailableLanesForCTCreation = 'getAvailableLanesForCTCreation',
    getPreviousOrdersByOrder = 'getPreviousOrdersByOrder',
    getLinkedOpportunity = 'getLinkedOpportunity',
    getSimulationById = 'getSimulationById',
    getRightsByName = 'getRightsByName',
    getLanesFromOpportunity = 'getLanesFromOpportunity',
    getOrderByNumber = 'getOrderByNumber',
    getQuoteDocuments = 'getQuoteDocuments',
    checkAwardedLanes = 'checkAwardedLanes',
    getLoggerDocuments = 'getLoggerDocuments',
    getAccounts = 'getAccounts',
    getOpportunitiesAll = 'getOpportunitiesAll',
    getAccountOptions = 'getAccountOptions',
    getLanesByQuote = 'getLanesByQuote',
    getCompanyParentSubsidiaries = 'getCompanyParentSubsidiaries',
    getCompanies = 'getCompanies',
    getPositioningSetup = 'getPositioningSetup',
    getOrderComments = 'getOrderComments',
    hasUnreadAlerts = 'hasUnreadAlerts',
    getOpportunitiesByQuote = 'getOpportunitiesByQuote',
    getAllAlertsNotifications = 'getAllAlertsNotifications',
    getForecastById = 'getForecastById',
    getPopulationOrderStep = 'getPopulationOrderStep',
    getLoggerModifications = 'getLoggerModifications',
    getActivityRecord = 'getActivityRecord',
    getActivityRecords = 'getActivityRecords',
    getPreBookings = 'getPreBookings',
    getPreBookingAvailableLanes = 'getPreBookingAvailableLanes',
    getPreBooking = 'getPreBooking',
    getPreBookingByParams = 'getPreBookingByParams',
    getPreBookingComments = 'getPreBookingComments',
    getLaneNotificationsSettings = 'getLaneNotificationsSettings',
    getPreBookingModifications = 'getPreBookingModifications',
    getPreBookingRequiredContainersChanges = 'getPreBookingRequiredContainersChanges',
    getAttachments = 'getAttachments',
    getEngagement = 'getEngagement',
    getEngagementByContactId = 'getEngagementByContactId',
    getContractBasisHasValidAdditionalFees = 'getContractBasisHasValidAdditionalFees',
    getCountries = 'getCountries',
    getAutoPopulatePosition = 'getAutoPopulatePosition',
    getCurrentMonthForecast = 'getCurrentMonthForecast',
    getLaneRequestedAwardedProductTypes = 'getLaneRequestedAwardedProductTypes',
    getServiceCenterById = 'getServiceCenterById',
    getAvailability = 'getAvailability',
    getOrderConfirmationAvailability = 'getOrderConfirmationAvailability',
    getDryStorage = 'getDryStorage',
    getTruckCapacity = 'getTruckCapacity',
    getLocationsByIds = 'getLocationsByIds',
    getDeployment = 'getDeployment',
    getServiceCenterByLocation = 'getServiceCenterByLocation',
    getContainerUnitPrice = 'getContainerUnitPrice',
    getLongTermLease = 'getLongTermLease',
    getLongTermLeaseComments = 'getLongTermLeaseComments',
    getAllowedContainerStatusTransitions = 'getAllowedContainerStatusTransitions',
    getDedicatedContainers = 'getDedicatedContainers',
    getLocationsByAccountCompany = 'getLocationsByAccountCompany',
    getBaseLeaseRateCards = 'getBaseLeaseRateCards',
    marginsFilterRequest = 'marginsFilterRequest',
    regionalServiceAvailabilityFilterRequest = 'regionalServiceAvailabilityFilterRequest',
    logisticsCostsFilterRequest = 'logisticsCostsFilterRequest',
    getOtherLaneFees = 'getOtherLaneFees',
    getAdditionalFeesRateCards = 'getAdditionalFeesRateCards',
    getCountryEmbargo = 'getCountryEmbargo',
    getRateCardsData = 'getRateCardsData',
    getDamageType = 'getDamageType',
    getSimplifiedQuoteFeesData = 'getSimplifiedQuoteFeesData',
    cQuotesFilterRequest = 'cQuotesFilterRequest',
    getCQuoteFeesData = 'getCQuoteFeesData',
    getCQuoteQuotationDetails = 'getCQuoteQuotationDetails',
    getCQuote = 'getCQuote',
    lanesFilterRequestAwardReject = 'lanesFilterRequestAwardReject',
    laneFeesFilterRequestAwardReject = 'laneFeesFilterRequestAwardReject',
    getCQuoteDocuments = 'getCQuoteDocuments',
    scenarioEditorInitialValues = 'scenarioEditorInitialValues',
    scenarioEditorContainerAvailability = 'scenarioEditorContainerAvailability',
    getProductMetrics = 'getProductMetrics',
    getSimplifiedCQuote = 'getSimplifiedCQuote',
    getContainerStatusBreakdown = 'getContainerStatusBreakdown',
    getContactsByAccount = 'getContactsByAccount',
    regionalGroupsFilterRequest = 'regionalGroupsFilterRequest',
    getSelectorLongTermLease = 'getSelectorLongTermLease',
    filterRequestAllAccount = 'filterRequestAllAccount',
    getOrderLink = 'getOrderLink',
    getChangeRequestApproval = 'getChangeRequestApproval',
    getFreightForwarder = 'getFreightForwarder',
    filterAllOutgoingInvoices = 'filterAllOutgoingInvoices',
    getHsCode = 'getHsCode',
    getServiceCenterModifications = 'getServiceCenterModifications',
}
